// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__wgH8c","gfeWrapper":"CalendarEvent_gfeWrapper__1iRj1"};